import { render, staticRenderFns } from "./Unassign.vue?vue&type=template&id=af74e2a2&"
import script from "./Unassign.vue?vue&type=script&lang=ts&"
export * from "./Unassign.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports